// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ButtonGroup_buttons_2xwDe"};